import { action, makeObservable, observable } from 'mobx';

class AuthStore {
    constructor() {
        makeObservable(this)
    }

    @observable userData: any = {
        isLogin: false,
        id: 0,
        token: '',
        language: '',
        dealer: null,
        stores: null,
        currency: null,
        discount_amount: 0,
        discounted_products: [],
        discounted_product_datas: []
    }

    @action setUserData(userData: any) {
        this.userData = userData;
    }
}

const store = new AuthStore();

export default store;